import { VistaDiagnosticsLog } from '@vista/diagnostics';
export const vistaDiagnosticLogInstance = new VistaDiagnosticsLog();
export const logger = {
    trace: (message, ...args) => vistaDiagnosticLogInstance.trace(message, ...args),
    debug: (message, ...args) => vistaDiagnosticLogInstance.debug(message, ...args),
    info: (message, ...args) => vistaDiagnosticLogInstance.info(message, ...args),
    warn: (message, ...args) => vistaDiagnosticLogInstance.warn(message, ...args),
    error: (message, ...args) => vistaDiagnosticLogInstance.error(message, ...args),
    registerProvider: (name, provider, configuration) => vistaDiagnosticLogInstance.registerProvider(name, provider, configuration)
};
